









































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import ConfirmationModal from '@/components/Commons/ConfirmationModal.vue';
@Component
export default class SelectedPassportlist extends Vue {
  @Prop() openPassportUploadModal;
  @Prop() editPassportDocument;
  $moment: any;
  $wlToastr: any;

  hasPassportDetails(passport) {
    return (
      passport.effectiveDate ||
      passport.expiryDate ||
      passport.userIdentificationNumber
    );
  }
  get passportUploadEnabled() {
    return false
  }

  get savedPassportList() {
    return vxm.passport.SavedPassportList.map((list) => {
      const country = vxm.passport.CountryList.find(
        (item) => item.countryId === list.identificationMasterId,
      );
      return {
        ...list,
        userIdentificationName: country.name,
        document: list.document || {},
      };
    });
  }
  isNotNull(val: any) {
    if (
      val == null ||
      val === null ||
      val == 'null' ||
      !Object.keys(val).length
    )
      return false;
    else return true;
  }
  transformDate(dttm: number): string {
    if (dttm === null) return '';
    return this.$moment(dttm).format(this.getCompanyDateFormat.toUpperCase());
  }
  get getCompanyDateFormat() {
    return vxm.jobs.getCompanyDateFormat;
  }
  isDateInPast(dttm: number): boolean {
    if (dttm === null) return false;
    var result = new Date(dttm);
    result.setDate(result.getDate() + 1);
    dttm = result.getTime();
    var expDate = new Date(dttm);

    var now = new Date();
    if (now > expDate) return true;
    else return false;
  }
  confirmDeletePassportDocument(passport) {
    this.$modal.show(
      ConfirmationModal,
      {
        header: this.$t('passport.delete.passport.document'),
        body: '',
        okText: this.$t('global.ok.text'),
        cancelText: this.$t('global.cancel-text'),
        onOk: async () => {
          const response: any = await vxm.passport.deletePassportDocument(
            passport.document.documentId,
          );
          if (response.meta.success) {
            this.$wlToastr(
              'success',
              this.$t('passport.document.delete.success'),
              this.$t('profile-accordion.passport'),
            );
          }
        },
      },
      {
        height: 'auto',
        clickToClose: false,
      },
    );
  }
  confirmDeletePassport(passport) {
    this.$modal.show(
      ConfirmationModal,
      {
        header: this.$t('passport.delete.passport'),
        body: '',
        okText: this.$t('global.ok.text'),
        cancelText: this.$t('global.cancel-text'),
        onOk: async () => {
          const response: any = await vxm.passport.deletePassport(passport);
          if (response.meta.success) {
            this.$wlToastr(
              'success',
              this.$t('passport.country.removed.success'),
              this.$t('profile-accordion.passport'),
            );
          }
        },
      },
      {
        height: 'auto',
        clickToClose: false,
      },
    );
  }

  async downloadResume(fileGUID, name) {
    try {
      const authToken = vxm.users.getToken;
      const url = '/wl-profile-svc/api/v2/user-profile/view/resume/' + fileGUID;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${authToken}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to download resume');
      }

      const blob = await response.blob();

      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = name || 'Passport';

      // Trigger a click event to initiate the download
      link.click();

      // Clean up the URL object after download
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Error downloading resume:', error);
    }
  }

  async previewDocument(docGUID) {
    try {
      const authToken = vxm.users.getToken;
      const url = '/wl-profile-svc/api/v2/user-profile/view/resume/' + docGUID;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${authToken}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to preview document');
      }

      // Open the document in a new tab
      window.open(response.url, '_blank');
    } catch (error) {
      console.error('Error previewing document:', error);
    }
  }
}
